import React, { useCallback, useState } from 'react';
import { Box, MenuItem, Select } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import { StudioControlStyles } from '../../styles';
import { setDropdownSelectMode, setGuideStudio } from '../../../../store/modules/studio/actions';
import { selectGuide } from '../../../../store/modules/studio/selectors';
import { guideOptions as options, GuideValues } from '../../../../configs/studio';
import StudioToolTip from '../../actions/StudioToolTip';
import StyledInput from '../../actions/StyledInput';

const GuideAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const guide = useSelector(selectGuide);
  const [open, setOpen] = useState(false);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);

  const onChangeHandler = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
    const eventValue = event.target.value as GuideValues;
    dispatch(setGuideStudio(eventValue));
  }, [dispatch]);

  return (
    <StudioToolTip title="The guide is the highlighted rectangle which can help to focus your reading.">
      <Box className={`${classes.selectionWrapper} ${classes.selectionWrapperGuide}`} mt={2}>
        <p className={classes.label}>Guide Position</p>
        <Select
          open={open}
          variant="outlined"
          className={clsx(classes.selection, classes.delayStartSelect, {

          })}
          input={<StyledInput />}
          value={guide}
          onChange={onChangeHandler}
          MenuProps={{ style: { zIndex: 2147483101 } }}
          data-intercom-target="Dropdown: Guide"
          id="studioGuideList"
          onOpen={openHandler}
          onClose={closeHandler}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </StudioToolTip>
  );
};

export default GuideAction;
